// 功能分组配置
const featureGroups = [
  {
    key: 'createProject',
    title: '创建项目',
    features: [
      { key: 'templates', label: '60万+模板资源', type: 'check' },
      { key: 'dailyProjects', label: '每天可创建项目数' },
      { key: 'questionsPerProject', label: '每个项目题目数上限' },
      { key: 'optionsPerQuestion', label: '每个选择题选项数上限' },
      { key: 'logic', label: '设置题目跳转和显示逻辑', type: 'check' },
      { key: 'onlineMedia', label: '项目添加在线音视频', type: 'check' },
      { key: 'localVideo', label: '项目添加本地视频' },
      { key: 'localAudio', label: '项目添加本地音频' },
      { key: 'attachment', label: '项目添加附件' },
      { key: 'customHeader', label: '自定义答题视频页眉', type: 'check' },
      { key: 'customLoading', label: '自定义答题加载动效', type: 'check' },
      { key: 'apprise', label: '360评估功能', type: 'check' },
    ],
  },
  {
    key: 'brandDemand',
    title: '品牌需求',
    features: [
      { key: 'noAds', label: '答题页面不展示广告' },
      { key: 'hideLogo', label: '隐藏答题页问卷网标志', type: 'check' },
      { key: 'replaceLogo', label: '替换答题页问卷网标志', type: 'check' },
      { key: 'customEmailSender', label: '自定义邮件分享发件地址', type: 'check' },
      { key: 'customSmsPrefix', label: '自定义短信前缀品牌签名', type: 'check' },
      { key: 'limitWechatOfficialAccountsAnswer', label: '关注品牌的服务号才能答题', type: 'check' },
      { key: 'limitWechatOfficialAccountsRedPacket', label: '关注品牌的服务号才能领红包', type: 'check' },
      { key: 'customDomain', label: '自定义答题链接域名' },
    ],
  },
  {
    key: 'collectResponses',
    title: '收集答卷',
    features: [
      { key: 'unlimitedResponses', label: '项目收集答卷数量无上限', type: 'check' },
      { key: 'sampleService', label: '有偿样本服务', type: 'check' },
      { key: 'phoneLimit', label: '限定手机号答题', type: 'check' },
      {
        key: 'ipLimit',
        label:
          '限定ip地址答题<a class="xingxing mouse-pointer" href="#target-aim" title="IP地址位置数据由纯真CZ88提供支持">*</a>',
        type: 'check',
      },
      { key: 'wechatRedPacket', label: '微信红包', type: 'check' },
      { key: 'smsShare', label: '通过短信分享问卷', type: 'check' },
      { key: 'emailShare', label: '通过邮件分享问卷', type: 'check' },
      { key: 'customLottery', label: '自定义抽奖', type: 'check' },
      { key: 'voteWall', label: '投票墙', type: 'check' },
      { key: 'wechatSignIn', label: '微信签到', type: 'check' },
      { key: 'quota', label: '配额', type: 'check' },
      //   { key: 'mapNavigation', label: '地图导航题', type: 'check' },
      //   { key: 'geolocation', label: '地理位置题精准定位', type: 'check' },
      { key: 'satisfactionSettings', label: '满意度维度设置', type: 'check' },
      { key: 'fileSizeLimit', label: '单个文件最大限制' },
      { key: 'spaceUploadLimit', label: '文件上传空间大小' },
    ],
  },
  {
    key: 'examFeatures',
    title: '考试功能',
    features: [
      { key: 'practiceMode', label: '练习模式', type: 'check' },
      { key: 'examAnswerSheet', label: '考试防作弊', type: 'check' },
      { key: 'examTimeLimit', label: '考试交卷时间设置', type: 'check' },
      { key: 'examRanking', label: '考试排行榜', type: 'check' },
      { key: 'scoreSettings', label: '按得分设置结束语', type: 'check' },
      { key: 'examCertificate', label: '考试证书', type: 'check' },
    ],
  },
  {
    key: 'teamCollaboration',
    title: '团队协作',
    features: [
      { key: 'projectOperation', label: '项目协作', type: 'check' },
      { key: 'publicShare', label: '项目数据公开分享', type: 'check' },
      { key: 'dataDownload', label: '分享项目数据支持下载', type: 'check' },
      { key: 'folderOperation', label: '文件夹协作', type: 'check' },
      { key: 'enterpriseAccount', label: '企业子账号（￥500/人/年）' },
      { key: 'enterpriseAccountPermission', label: '企业子账号权限管理', type: 'check' },
    ],
  },
  {
    key: 'systemIntegration',
    title: '系统集成',
    features: [
      { key: 'customSource', label: '自定义答题来源', type: 'check' },
      { key: 'customAnswerParams', label: '自定义答卷参数', type: 'check' },
      { key: 'customJumpUrl', label: '打开答题页时跳转指定页面', type: 'check' },
      { key: 'customSubmitJumpUrl', label: '提交答卷后跳转指定页面', type: 'check' },
      { key: 'customOpenApi', label: '开放平台API对接', type: 'check' },
      { key: 'customOpenMessagePush', label: '开放平台消息推送', type: 'check' },
    ],
  },
]

const packagePricingPlans = {
  free: {
    id: 'free',
    name: '免费版',
    icon: 'primarypc.png',
    price: {
      value: '永久免费',
    },
    description: '提供完善的问卷编辑基础功能，适用于大多数个人用户',
    features: {
      // 创建项目
      templates: { available: true },
      dailyProjects: { text: '20个' },
      questionsPerProject: { text: '1000题' },
      optionsPerQuestion: { text: '200个' },
      logic: { available: true },
      onlineMedia: { available: true },
      localVideo: { available: false },
      localAudio: { available: false },
      attachment: { available: false },
      customHeader: { available: false },
      customLoading: { available: false },
      apprise: { available: false },
      // 品牌需求
      noAds: { available: false },
      hideLogo: { available: false },
      replaceLogo: { available: false },
      customEmailSender: { available: false },
      customSmsPrefix: { available: false },
      limitWechatOfficialAccountsAnswer: { available: false },
      limitWechatOfficialAccountsRedPacket: { available: false },
      customDomain: { available: false },
      // 收集答卷功能
      unlimitedResponses: { available: true },
      sampleService: { available: true },
      phoneLimit: { available: true },
      ipLimit: { available: true },
      wechatRedPacket: { available: true },
      smsShare: { available: true },
      emailShare: { available: true },
      customLottery: { available: false },
      voteWall: { available: false },
      wechatSignIn: { available: false },
      quota: { available: false },
      satisfactionSettings: { available: false },
      fileSizeLimit: { text: '30MB' },
      spaceUploadLimit: { text: '1GB/月（不可增购）' },
      // 考试功能
      practiceMode: { available: true },
      examAnswerSheet: { available: true },
      examTimeLimit: { available: true },
      examRanking: { available: true },
      scoreSettings: { available: true },
      examCertificate: { available: false },
      // 团队协作
      projectOperation: { available: true },
      publicShare: { available: false },
      dataDownload: { available: true },
      folderOperation: { available: false },
      enterpriseAccount: { available: false },
      enterpriseAccountPermission: { available: false },
      // 系统集成
      customSource: { available: false },
      customAnswerParams: { available: false },
      customJumpUrl: { available: false },
      customSubmitJumpUrl: { available: false },
      customOpenApi: { available: false },
      customOpenMessagePush: { available: false },
    },
  },
  advance_version: {
    id: 'advance_version',
    name: '高级版',
    icon: 'seniorpc.png',
    description: '适用于对专业性功能要求更高，期望隐藏答题页商业推广的个人用户',
    paymentTypes: {
      month: {
        unit: '￥',
        value: 369,
        period: '月',
        priceText: '免广告5千次',
        features: {
          noAds: { text: '5千次（可增购）' },
          spaceUploadLimit: { text: '5G/月（可增购）' },
        },
      },
      year: {
        unit: '￥',
        value: 2499,
        period: '年',
        priceText: '月均仅需约208元',
        features: {
          noAds: { text: '10万次（可增购）' },
          spaceUploadLimit: { text: '10GB/月（可增购）' },
        },
      },
    },
    features: {
      // 创建项目
      templates: { available: true },
      dailyProjects: { text: '50个' },
      questionsPerProject: { text: '1200题' },
      optionsPerQuestion: { text: '300个' },
      logic: { available: true },
      onlineMedia: { available: true },
      localVideo: { text: '最大50MB/个' },
      localAudio: { text: '最大10MB/个' },
      attachment: { available: false },
      customHeader: { available: false },
      customLoading: { available: false },
      apprise: { available: false },
      // 品牌需求
      hideLogo: { available: true },
      replaceLogo: { available: false },
      customEmailSender: { available: false },
      customSmsPrefix: { available: false },
      limitWechatOfficialAccountsAnswer: { available: false },
      limitWechatOfficialAccountsRedPacket: { available: false },
      customDomain: { available: false },
      // 收集答卷功能
      unlimitedResponses: { available: true },
      sampleService: { available: true },
      phoneLimit: { available: true },
      ipLimit: { available: true },
      wechatRedPacket: { available: true },
      smsShare: { available: true },
      emailShare: { available: true },
      customLottery: { available: true },
      voteWall: { available: true },
      wechatSignIn: { available: true },
      quota: { available: true },
      satisfactionSettings: { available: true },
      fileSizeLimit: { text: '50MB' },
      // 考试功能
      practiceMode: { available: true },
      examAnswerSheet: { available: true },
      examTimeLimit: { available: true },
      examRanking: { available: true },
      scoreSettings: { available: true },
      examCertificate: { available: false },
      // 团队协作
      projectOperation: { available: true },
      publicShare: { available: true },
      dataDownload: { available: true },
      folderOperation: { available: false },
      enterpriseAccount: { available: false },
      enterpriseAccountPermission: { available: false },
      // 系统集成
      customSource: { available: false },
      customAnswerParams: { available: false },
      customJumpUrl: { available: false },
      customSubmitJumpUrl: { available: false },
      customOpenApi: { available: false },
      customOpenMessagePush: { available: false },
    },
  },
  enterprise_version: {
    id: 'enterprise_version',
    name: '企业版',
    icon: 'enterprisepc.png',
    description: '适用于有项目协作需求，及在答题页对品牌形象展现有要求的企业或团队用户',
    paymentTypes: {
      month: {
        unit: '￥',
        value: 1999,
        period: '月',
        priceText: '免广告2万次',
        features: {
          noAds: { text: '2万次（可增购）' },
          spaceUploadLimit: { text: '15G/月（可增购）' },
        },
      },
      year: {
        unit: '￥',
        value: 5499,
        period: '年',
        priceText: '月均仅需约458元',
        features: {
          noAds: { text: '30万次（可增购）' },
          spaceUploadLimit: { text: '20GB/月（可增购）' },
        },
      },
    },
    features: {
      // 创建项目
      templates: { available: true },
      dailyProjects: { text: '80个' },
      questionsPerProject: { text: '1400题' },
      optionsPerQuestion: { text: '400个' },
      logic: { available: true },
      onlineMedia: { available: true },
      localVideo: { text: '最大100MB/个' },
      localAudio: { text: '最大20MB/个' },
      attachment: { text: '最大20MB/个' },
      customHeader: { available: true },
      customLoading: { available: true },
      apprise: { available: true },
      // 品牌需求
      hideLogo: { available: true },
      replaceLogo: { available: true },
      customEmailSender: { available: true },
      customSmsPrefix: { available: true },
      limitWechatOfficialAccountsAnswer: { available: true },
      limitWechatOfficialAccountsRedPacket: { available: true },
      customDomain: { text: '支持http' },
      // 收集答卷功能
      unlimitedResponses: { available: true },
      sampleService: { available: true },
      phoneLimit: { available: true },
      ipLimit: { available: true },
      wechatRedPacket: { available: true },
      smsShare: { available: true },
      emailShare: { available: true },
      customLottery: { available: true },
      voteWall: { available: true },
      wechatSignIn: { available: true },
      quota: { available: true },
      satisfactionSettings: { available: true },
      fileSizeLimit: { text: '100MB' },
      // 考试功能
      practiceMode: { available: true },
      examAnswerSheet: { available: true },
      examTimeLimit: { available: true },
      examRanking: { available: true },
      scoreSettings: { available: true },
      examCertificate: { available: true },
      // 团队协作
      projectOperation: { available: true },
      publicShare: { available: true },
      dataDownload: { available: true },
      folderOperation: { available: true },
      enterpriseAccount: { text: '10个（可增购）' },
      enterpriseAccountPermission: { available: true },
      // 系统集成
      customSource: { available: true },
      customAnswerParams: { available: true },
      customJumpUrl: { available: true },
      customSubmitJumpUrl: { available: true },
      customOpenApi: { available: true },
      customOpenMessagePush: { available: true },
    },
  },
  enterprise_ultimate_version: {
    id: 'enterprise_ultimate_version',
    name: '企业旗舰版',
    icon: 'ultimatepc.png',
    description: '适用于需要大量成员协作，且对各类数据限制有更高要求的企业用户',
    price: {
      unit: '￥',
      value: 24999,
      period: '年',
      priceText: '月均约2083元',
    },
    features: {
      // 创建项目
      templates: { available: true },
      dailyProjects: { text: '100个' },
      questionsPerProject: { text: '1600题' },
      optionsPerQuestion: { text: '500个' },
      logic: { available: true },
      onlineMedia: { available: true },
      localVideo: { text: '最大200MB/个' },
      localAudio: { text: '最大50MB/个' },
      attachment: { text: '最大50MB/个' },
      customHeader: { available: true },
      customLoading: { available: true },
      apprise: { available: true },
      // 品牌需求
      noAds: { text: '150万次（可增购）' },
      hideLogo: { available: true },
      replaceLogo: { available: true },
      customEmailSender: { available: true },
      customSmsPrefix: { available: true },
      limitWechatOfficialAccountsAnswer: { available: true },
      limitWechatOfficialAccountsRedPacket: { available: true },
      customDomain: { text: '支持http和https' },
      // 收集答卷功能
      unlimitedResponses: { available: true },
      sampleService: { available: true },
      phoneLimit: { available: true },
      ipLimit: { available: true },
      wechatRedPacket: { available: true },
      smsShare: { available: true },
      emailShare: { available: true },
      customLottery: { available: true },
      voteWall: { available: true },
      wechatSignIn: { available: true },
      quota: { available: true },
      satisfactionSettings: { available: true },
      fileSizeLimit: { text: '200MB' },
      spaceUploadLimit: { text: '50GB/月（可增购）' },
      // 考试功能
      practiceMode: { available: true },
      examAnswerSheet: { available: true },
      examTimeLimit: { available: true },
      examRanking: { available: true },
      scoreSettings: { available: true },
      examCertificate: { available: true },
      // 团队协作
      projectOperation: { available: true },
      publicShare: { available: true },
      dataDownload: { available: true },
      folderOperation: { available: true },
      enterpriseAccount: { text: '30个（可增购）' },
      enterpriseAccountPermission: { available: true },
      // 系统集成
      customSource: { available: true },
      customAnswerParams: { available: true },
      customJumpUrl: { available: true },
      customSubmitJumpUrl: { available: true },
      customOpenApi: { available: true },
      customOpenMessagePush: { available: true },
    },
  },
}

export { featureGroups, packagePricingPlans }
